export default String.raw`
.mblist {
  &-container {
      height: fit-content;
      min-height: 100vh;
      display: block;
      background-color: $bgColor;

      .pure-button {
        display: block;
        margin: 0 auto 24px;
      }
  }
  
  &-header {
    @include h1-headline;
    display: block;
    width: 100%;
    color: $primaryColorFont;
    margin-top: 24px;
  }

  &-wrapper {
      display: grid;
      grid-row-gap: 32px;
      padding: 32px 0;
      justify-content: space-around;
      grid-column-gap: 24px;
  }

  &-item {
      transition: all 0.3s linear;
      background-color: $bgColor;
      cursor: pointer;
      height: 110px;

      &:hover {
          box-shadow: 0 10px 10px 10px rgba(0, 0, 0, 0.12);
          border-radius: 8px;
          .mblist-item--name {
              color: $primaryColorFont;
          }
      }

      &--imgContainer {
          display: flex;
          width: 100%;
          height: 50px;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          
          img {
              display: block;
              max-width: 95%;
              width: auto;
              max-height: 50px;
              height: auto;
          }
      }

      &--name {
        @include subtitle-medium;
        color: $primaryColorFont;
        width: 100%;
        text-align: center !important;
        word-wrap: break-word;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding: 4px 8px;
        transition: 0.3s;
      }
  }
}

@media screen and (min-width: 1025px) {
    .mblist {
        &-wrapper {
            grid-template-columns: 14% 14% 14% 14% 14% 14%;
        }
    }
}
@media screen and (min-width: 500px) and (max-width: 1024px) {
    .mblist {
        &-wrapper {
            grid-template-columns: 21% 21% 21% 21%;
        }
    }
}
`